import { Component, OnInit } from '@angular/core';
import { MemberService } from '../../Services/member.service';
import { StockService } from '../../Services/stock.service';
import Swal from 'sweetalert2';
import { OrderService } from '../../Services/order.service';
@Component({
  selector: 'app-stock',
  template: require('./stock.component.html'),
  styles: [require('./stock.component.css')]
})
export class StockComponent implements OnInit {

  stock:any = [];
  members: any[] = [];

  nameSearchString: string = '';
  searched_members: any[] = [];
  firstnames: any[] = [];
  lastnames: any[] = [];

  showMaleOnly = false;
  showFemaleOnly = false;
  showAll = true;
  selected_desc = "";
  uniqueDescriptions: any[] = [];
  selected_stock: any[] = [];


  current_member: any ={
    firstName: "",
    lastName: "",
    id: -1
  };
  current_stock_item:any = {
    "id": -1,
    "clothesId": -1,
    "amount": -1,
    "clothes": {
        "id": -1,
        "isFemale": false,
        "isMale": false,
        "description": "",
        "price": 0,
        "image": "",
        "title": "",
    },
    "size": "3",
  }
  current_amount = 1
  cart:any = {
    items:[],
    total_price:0,
    total_amount:0
  }

  memberDiscount: any ={
    amountClothesLeft: 0.0,
  }

  constructor(private stockService: StockService, private memberService: MemberService, private orderService:OrderService) { }


  ngOnInit() {
    this.loadAllMembers();  
    this.loadStock();
  }

  loadStock(){
    this.stockService.getStockItems().subscribe( (x:any)=>{
      this.stock = x;
      this.emptyCart();
      this.clearMember();
      this.selectAll();
      this.clearUniqueDesc();
      this.loadSelectedStock();

    })
  }

  emptyCart(){
   this.cart = {
      items:[],
      total_price:0,
      total_amount:0
    }
  }

  loadAllMembers(){
    this.memberService.getSimpleMembers().subscribe ((res:any) => {
      this.members = res;
    })
  }

  searchName(){
    if (this.nameSearchString.length > 0){
      this.firstnames = this.members.filter( a => a.firstName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      this.lastnames = this.members.filter( a => a.lastName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      this.searched_members = this.firstnames.concat(this.lastnames);
    }else{
      this.searched_members = this.members
    }
 }


  selectedMember(id: number){
    if (id > 0){
      let m = this.members.filter( a => a.id == id);
      if (m.length > 0){
        this.current_member = m[0]
        this.getDiscountLeft();
      }
      else {
        this.current_member = {
          firstName : "",
          lastName: ""
        }
      }
    }
  }

  clearMember(){
    this.current_member ={
      firstName: "",
      lastName: "",
      id: -1
    };
    
    this.memberDiscount = {
      amountClothesLeft: 0.0,
    }
  
  }

  getFromStock(id: number){
    this.current_stock_item = this.stock.find( (s:any) => s.id == id)
    this.current_amount = 1
  }

  amountChanged(id: number, amount:number){
    this.current_amount = amount;
  }

  AddToCart(){
    let item = this.stock.find( (i:any)=> i.id == this.current_stock_item.id)
    
    item.amount = item.amount - this.current_amount
   
    let i = {
      amount: new Number(this.current_amount),
      item: this.current_stock_item
    }

    this.cart.items.push(i);
    this.calculateTotalPrice()
  }

  calculateTotalPrice(){
    var total = 0
    var amount = 0
    this.cart.items.forEach( (i:any) => {
      total += (i.item.clothes.price * i.amount);
      amount += parseInt(i.amount);
    });
    this.cart.total_price = total;
    this.cart.total_amount = amount;
   
  }

  deleteFromCart(id: number){
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je dit wil verwijderen?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        const index = this.cart.items.findIndex((d:any) => d.id === id);
        if (index > -1) {
          let  item_to_delete = this.cart.items[index];
          let i = this.stock.find( (i:any)=> i.id == item_to_delete.item.id)
          console.log("item to delte: ");
          console.log(item_to_delete);
          console.log("i:");
          console.log(i);
          
          
          i.amount = i.amount + item_to_delete.amount
          this.cart.items.splice(index, 1);
        }
        this.calculateTotalPrice();
      }
    });
  }

  getDiscountLeft(){   
    if (this.current_member.id > -1){
      this.orderService.getDiscountLeftForId(this.current_member.id).subscribe( x =>{
        if (x.status == 200){
          this.memberDiscount = x.value;
        }
      });
    }else {
      this.memberDiscount = {
          amountClothesLeft: 0.0,
      }
    }
  }

  TransferStockToUser(){
    var items:any = []
    this.cart.items.forEach( (i:any) => {
      
      var x = { "StockItemId": i.item.id,
                "ClothesId": i.item.clothes.id,
                "Amount":i.amount,
                "Size":i.item.size,
                "OrderId": i.item.orderId,
              }
      items.push(x);
      
    });

    var data = {
                "items": items,
                "memberId": this.current_member.id
              }

    this.stockService.transferStock(data).subscribe( (res:any)=>{
      if (res.status == 200){
        this.clearMember();
        this.emptyCart();
        Swal.fire({
          title: 'Uitgegeven!',
          type: 'success',
          html:
            'Item(s) uitgegeven.',
            
          showCloseButton: false,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
      }
    })   
  }

  selectMale(){
    this.showFemaleOnly = false;
    this.showMaleOnly = true;
    this.clearUniqueDesc();
    this.loadSelectedStock();
    this.createUniqueDescList();
  }

  selectFemale(){
    this.showFemaleOnly = true;
    this.showMaleOnly = false;
    this.clearUniqueDesc();
    this.loadSelectedStock();
    this.createUniqueDescList();
  }
  selectAll() {
    this.showFemaleOnly = false;
    this.showMaleOnly = false;
    this.showAll = true;
    this.clearUniqueDesc();
    this.loadSelectedStock();
    this.createUniqueDescList();
  }

  loadSelectedStock(){
    if (this.showFemaleOnly || this.showMaleOnly){
      this.selected_stock = this.stock.filter( (a:any) => ( (a.clothes.isMale == this.showMaleOnly) && (a.clothes.isFemale == this.showFemaleOnly) ) ) ;
    }
    else{
      this.selected_stock = this.stock;
    }   
    this.createUniqueDescList();
  }

  createUniqueDescList(){
    var uniqueSet = new Set()
    this.selected_stock.forEach(e => {
      uniqueSet.add(e.clothes.description)
    });
    const uniqueArray = Array.from(uniqueSet);
    this.uniqueDescriptions = uniqueArray.sort()
  }

  filterOnDescription(){
    this.loadSelectedStock();
    this.selected_stock = this.selected_stock.filter( (a:any)=>( a.clothes.description == this.selected_desc ) )
  }

  setUniqueDesc(s: string){
    this.selected_desc = s;
    this.filterOnDescription();
  }

  clearUniqueDesc(){
    this.selected_desc = "";
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/stock/stock.component.ts